import React from 'react';
import classes from './education.module.css';

import EducationItem from './educationitem';

const Education = () => {

    const school1 = "Graduate School of Engineering, Nagoya University";
    const major1 = "Department of Information and Communication Engineering (2019 - current)"

    const school2 = "School of Engineering, Nagoya University";
    const major2 = "Electrical and Electronic Engineering and Information Engineering (2015 - 2019)"


    return (
        <div className={classes.container}>
            <h3>Education</h3>
            <EducationItem school={school1} major={major1}/>
            <EducationItem school={school2} major={major2}/>
        </div>
    );
}

export default Education;